import React from "react";
import Typography from "material-ui/Typography";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import {
  nwTestData,
  transTestData,
  wireTestData,
  poeTestData
} from "./subtestsenum";
import {
  FormControlLabel,
  FormGroup
} from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Grid from "material-ui/Grid";

const DeleteSubTests = props => (
  <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="sm"
    fullWidth={true}
    open={props.open}
  >
    <DialogTitle className={props.classes.title}>
      {props.title}
      <Button className={props.classes.close} onClick={props.onCancel}>
        <Icon>clear</Icon>
      </Button>
    </DialogTitle>
    <DialogContent>
      <Typography gutterBottom className={props.classes.HighlightUserDetails}>
        {props.contentText}
      </Typography>
      <Grid container>
        <Grid item xs={5}>
          <FormGroup>
            {nwTestData
              ? nwTestData.map((item, index) => {
                return (
                  <FormControlLabel
                    className={props.classes.textFieldL}
                    control={
                      <Checkbox
                        name={item.id}
                        checked={props.subTests[item.id]}
                        onChange={props.onSubtestChange}
                        value={props.subTests[item.id]}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={props.classes.lookup}>
                        {props.translate(item.id)}
                      </Typography>
                    }
                  />
                );
              })
              : null}
            {!props.isSignalTEKQTJob && wireTestData
              ? wireTestData.map((item, index) => {
                return (
                  <FormControlLabel
                    className={props.classes.textFieldL}
                    control={
                      <Checkbox
                        name={item.id}
                        checked={props.subTests[item.id]}
                        onChange={props.onSubtestChange}
                        value={props.subTests[item.id]}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={props.classes.lookup}>
                        {props.translate(item.id)}
                      </Typography>
                    }
                  />
                );
              })
              : null}
            {poeTestData
              ? poeTestData.map((item, index) => {
                return (
                  <FormControlLabel
                    className={props.classes.textFieldL}
                    control={
                      <Checkbox
                        name={item.id}
                        checked={props.subTests[item.id]}
                        onChange={props.onSubtestChange}
                        value={props.subTests[item.id]}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={props.classes.lookup}>
                        {props.translate(item.id)}
                      </Typography>
                    }
                  />
                );
              })
              : null}
          </FormGroup>
        </Grid>
        {!props.isSignalTEKQTJob && (
        <Grid item xs={7}>
          <FormGroup>
            {transTestData
              ? transTestData.map((item, index) => {
                return (
                  <FormControlLabel
                    className={props.classes.textFieldL}
                    control={
                      <Checkbox
                        name={item.id}
                        checked={props.subTests[item.id]}
                        onChange={props.onSubtestChange}
                        value={props.subTests[item.id]}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={props.classes.lookup}>
                        {props.translate(item.id)}
                      </Typography>
                    }
                  />
                );
              })
              : null}
          </FormGroup>
        </Grid>
        )}
      </Grid>
    </DialogContent>
    <DialogActions>
      {props.okDeleteTestText && (
        <Button
          className={props.classes.submit}
          onClick={props.onDeleteTest}
          color="primary"
        >
          {props.okDeleteTestText}
        </Button>
      )}
    </DialogActions>
  </Dialog>
);
export default withStyles(styles)(DeleteSubTests);



// WEBPACK FOOTER //
// ./src/components/job/signaltek10g/delete/deletesubtests/index.js